// extracted by mini-css-extract-plugin
module.exports = {"optTargetFunction":"styles_optTargetFunction__2Mh-1","headlineContainer":"styles_headlineContainer__383fD","button":"styles_button__2CClA","invisible":"styles_invisible__1Eovs"};